import { Alert } from '@mui/material';
import React from 'react';

export default function DataNotAvailable() {
  return (
    <Alert severity={'info'}>Data is not available</Alert>
  );
}